module.exports = __webpack_public_path__ + "img/swords.7d44b731.svg";